import React, { Component } from "react";
import { connect } from "react-redux";
import { AttachmentModal } from "../";
import * as attachmentActions from "../../redux/modules/attachments/actionCreators";

// TODO: Add PropTypes
@connect(
  (state) => ({
    selected:
      Object.keys(state.issues.selected).length > 0
        ? state.issues.selected
        : state.issues.issue,
    uploadAttachment: state.attachments.uploadAttachment,
  }),
  {
    ...attachmentActions,
  }
)
class IssuePaneModals extends Component {
  render() {
    const {
      uploadAttachment,
      endUploadAttachment,
      handleAddAttachment,
      selected,
    } = this.props;

    return (
      <AttachmentModal
        endUploadAttachment={endUploadAttachment}
        handleAddAttachment={handleAddAttachment}
        uploadAttachment={uploadAttachment}
        id={selected.key}
      />
    );
  }
}

export default IssuePaneModals;
